import React, { useEffect } from 'react'
import {
  matchPath,
  Navigate,
  Outlet,
  useLocation,
  useSearchParams,
} from 'react-router-dom'
import { notification } from 'antd'
import { PATH } from 'src/pages/myPage'
import LocalStorage from 'src/utils/LocalStorage'
import { PATH as PATH_AUTH } from 'src/pages/auth'
import { useAppDispatch, useAppSelector } from 'src/store'
import choicesUserAction from 'src/store/domain/choicesUser/details'
import { get } from 'lodash'

const RestrictLayout: React.FC = () => {
  const accessToken = LocalStorage.accessToken
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const authInfo = useAppSelector((state) => state.ui.app.authInfo)

  const uuid = searchParams.get('uuid')
  const clinicId = searchParams.get('clinicId')
  const planId = searchParams.get('planId')
  const menuId = searchParams.get('menuId')
  const from = searchParams.get('from')
  const telemedicine = LocalStorage.getTelemedicine()
  const matchClinic = matchPath('/clinics/:clinic_uuid', location.pathname)
  const isClinicRoute = Boolean(matchClinic)
  const clinicUuidFromPath = get(matchClinic, 'params.clinic_uuid')

  const currentUuid = uuid || clinicUuidFromPath
  const userClinicUuid = get(authInfo, 'clinics.0.uuid')

  useEffect(() => {
    if (uuid) {
      LocalStorage.setClinicUuid(uuid)
    }
    if (clinicId || planId || menuId || from) {
      dispatch(
        choicesUserAction.setChoicesData({
          clinicId: clinicId || '',
          menuId: menuId || '',
          planId: planId || '',
          from: from || '',
        }),
      )
    }
  }, [uuid, clinicId, planId, menuId, from, dispatch])

  const settingPwdRoutes = [
    PATH_AUTH.SEND_MAIL_SETTING_PASSWORD,
    PATH_AUTH.SETTING_PASSWORD_PATH,
  ]

  if (
    accessToken &&
    from === 'mail' &&
    settingPwdRoutes.find((route) => matchPath(route, window.location.pathname))
  ) {
    return <Navigate to={`${PATH.UPDATE_PASSWORD_PATH}`} />
  }

  const modalRoutes = [
    PATH_AUTH.PRECAUTION_MODAL_PLAN,
    PATH_AUTH.PRECAUTION_MODAL_ONLINE,
    PATH_AUTH.MEDICAL_SPECIALTY,
    PATH_AUTH.CHECK_USER_EXISTS_MODAL,
  ]

  const isRegisterRoute = Boolean(
    matchPath(PATH_AUTH.REGISTER, location.pathname),
  )

  const isModalRoute = Boolean(
    modalRoutes.find((route) => matchPath(route, location.pathname)),
  )

  if (accessToken && isRegisterRoute) {
    return <Navigate to={PATH.OTHER_MENU} replace />
  }

  if (isModalRoute || isRegisterRoute) {
    return <Outlet />
  }

  if (accessToken) {
    const isMismatchClinic =
      currentUuid && userClinicUuid && currentUuid !== userClinicUuid
    const isNotTelemedicine = !isClinicRoute && telemedicine === 'false'

    if (isMismatchClinic || isNotTelemedicine) {
      const userClinicId = get(authInfo, 'clinics.0.id')
      const currentClinicId = userClinicId || clinicId

      const params = new URLSearchParams()
      if (currentUuid) params.set('uuid', currentUuid)
      if (currentClinicId) params.set('clinicId', currentClinicId)
      if (from) params.set('from', from)

      if (!isMismatchClinic) {
        if (menuId) params.set('menuId', menuId)
        if (planId) params.set('planId', planId)
      }

      if (isMismatchClinic) {
        notification.warning({
          message:
            '選択された店舗（サロン）が前回と異なります。ご確認ください。',
        })
      }

      return (
        <Navigate
          to={`${PATH_AUTH.MEDICAL_SPECIALTY}?${params.toString()}`}
          replace
        />
      )
    }
  }

  return <Outlet />
}

export default RestrictLayout
